module.exports = __webpack_public_path__ + "img/highlights_industry.png";